import { interopDefault } from '~/router/utils'

export default [
  {
    name: '__landing_pages_trades',
    path: '/landing/trades/',
    meta: { isLanding: true },
    component: () =>
      interopDefault(
        import(
          '~/pages/landing/trades.vue' /* webpackChunkName: "pages-landing-trades.vue" */
        )
      )
  },
  {
    name: '__landing_pages_rentals',
    path: '/landing/rentals/',
    meta: { isLanding: true },
    component: () =>
      interopDefault(
        import(
          '~/pages/landing/rentals.vue' /* webpackChunkName: "pages-landing-rentals.vue" */
        )
      )
  },
  {
    name: '__landing_pages_promotions',
    path: '/landing/promotions/',
    meta: { isLanding: true },
    component: () =>
      interopDefault(
        import(
          '~/pages/landing/promotions.vue' /* webpackChunkName: "pages-landing-promotions.vue" */
        )
      )
  },
  {
    name: '__landing_pages_finance',
    path: '/landing/finance/',
    meta: { isLanding: true },
    component: () =>
      interopDefault(
        import(
          '~/pages/landing/finance.vue' /* webpackChunkName: "pages-landing-finance.vue" */
        )
      )
  },
  {
    name: '__landing_pages_audits',
    path: '/landing/audits/',
    meta: { isLanding: true },
    component: () =>
      interopDefault(
        import(
          '~/pages/landing/audits.vue' /* webpackChunkName: "pages-landing-audits.vue" */
        )
      )
  },
  {
    name: '__landing_pages_wanted_parts',
    path: '/landing/wanted-parts/',
    meta: { isLanding: true },
    component: () =>
      interopDefault(
        import(
          '~/pages/landing/wanted-parts.vue' /* webpackChunkName: "pages-landing-wanted-parts.vue" */
        )
      )
  },
  {
    name: '__landing_pages_marketplace_sellers',
    path: '/landing/marketplace-sellers/',
    meta: { isLanding: true },
    component: () =>
      interopDefault(
        import(
          '~/pages/landing/marketplace-sellers.vue' /* webpackChunkName: "pages-landing-marketplace-sellers.vue" */
        )
      )
  },
  {
    name: '__landing_pages_marketplace',
    path: '/landing/marketplace/',
    meta: { isLanding: true },
    component: () =>
      interopDefault(
        import(
          '~/pages/landing/marketplace.vue' /* webpackChunkName: "pages-landing-marketplace.vue" */
        )
      )
  },
  {
    name: '__landing_pages_perks',
    path: '/landing/perks/',
    meta: { isLanding: true },
    component: () =>
      interopDefault(
        import(
          '~/pages/landing/perks.vue' /* webpackChunkName: "pages-landing-perks.vue" */
        )
      )
  },
  {
    name: '__landing_stay_safe',
    path: '/landing/stay-safe/',
    meta: { isLanding: true },
    component: () =>
      interopDefault(
        import(
          '~/pages/landing/stay-safe.vue' /* webpackChunkName: "pages-landing-stay-safe.vue" */
        )
      )
  },
  {
    name: '__sale_requests_landing',
    path: '/landing/sale-requests',
    component: () =>
      interopDefault(
        import(
          '~/pages/landing/sale-requests.vue' /* webpackChunkName: "pages-landing-sale-requests.vue" */
        )
      )
  }
]
